import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import React, { useEffect } from 'react'

import { Button } from 'core-components/library/button'
import { refreshActionRequest } from 'onboarding/features/actions/refreshActionRequestAction'

import { RejectRequest } from '../../../../requestDetail/rejectRequest/RejectRequest'
import { Warning } from '../content/Warning'

import { EPendingRequestStatus, useModalStateAndHandlers } from './useModalStateAndHandlers'

import modalStyles from './../PartnerIdModalDialog.module.scss'

interface IProps {
  closeModal: () => void
  closeAllModals: () => void
  request: IRequest
  openModal: () => void
  isVisibleModal: boolean
}

export const useChangePartnerId = ({
  closeModal,
  closeAllModals,
  request,
  openModal,
  isVisibleModal,
}: IProps) => {
  const {
    state,
    handlers: { cancelAndCloseModal, changePartnerId, submitChangePartner, showPreloader },
    pendingRequestStatus,
    resetPendingRequestStatus,
  } = useModalStateAndHandlers({
    closeModal,
    requestId: request.EntryId,
    requestType: request.Type,
  })
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!isVisibleModal) {
      resetPendingRequestStatus()
      cancelAndCloseModal()
    }
  }, [isVisibleModal])

  useEffect(() => {
    const checkPendingRequestStatus = async () => {
      if (pendingRequestStatus === EPendingRequestStatus.absent) {
        await submitChangePartner()
        closeAllModals()
      } else if (pendingRequestStatus === EPendingRequestStatus.exist) {
        openModal()
      }
    }
    checkPendingRequestStatus()
  }, [pendingRequestStatus])

  const rejectChangePartner = () => {
    dispatch(refreshActionRequest())
    closeAllModals()
  }

  return {
    getModalContent: () => (
      <div>
        {state.existingPendingRequestOfChosenPartner ? (
          <div className={modalStyles.root}>
            <div className={modalStyles.warningWrapper}>
              <Warning
                requestId={state.existingPendingRequestOfChosenPartner.EntryId}
                requestSpecializationName={
                  state.existingPendingRequestOfChosenPartner.SpecializationName
                }
              />
            </div>

            <div className={modalStyles.buttonsContainer}>
              <RejectRequest
                requestId={request.EntryId}
                reqType={request.Type}
                currentComment={request.Comment}
                buttonText={'Reject current request'}
                doBeforeSave={showPreloader}
                doAfterSave={rejectChangePartner}
              />
              <span className={modalStyles.cancelButtonWrapper}>
                <Button color={'danger'} onClick={() => closeModal()}>
                  {'Cancel'}
                </Button>
              </span>
            </div>
          </div>
        ) : null}
      </div>
    ),
    closeModal,
    changePartnerId,
    showPreloader: state.showPreloader,
  }
}
